import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

function GameNotes({ notes }) {
  if(!notes.length){
    return (
      <List>
        <ListItem>
          <ListItemText primary="No game notes." />
        </ListItem>
      </List>
    )
  }

  return (
    <List>
      { notes.map((note, idx) => (
        <ListItem key={idx}>
          <ListItemText primary={note.description} secondary={note.type} />
        </ListItem>
      ))}
    </List>
  )
}

export default GameNotes;
